import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { Add, ArrowBack } from "@mui/icons-material";
import _ from "../../../util/lodash";
import toast from "react-hot-toast";
import useForm from "../../../hooks/useForm";
import { BASE_URL } from "../../../actionTypes";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductPriceLevel,
  saveProductPriceLevel,
  updateProductPriceLevel,
} from "../../../redux/product-price-level/productPriceLevelSlice";
import { getProductCategorys } from "../../../redux/product-category/productCategorySlice";
import { update } from "lodash";
import { getProductUnits } from "../../../redux/product-unit/productUnitSlice";
import { useTranslation } from "react-i18next";

const defaultForm = {
  id: "",
  product_category_id: "",
  product_unit_id: "",
  level_name: "",
  level_description: "",
  created_by: "",
  created_date: "",
  updated_by: "",
  updated_date: "",
  Category: null,
};

const CreateProductPriceLevel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;
  const { form, resetForm, handleChange, setForm } = useForm(defaultForm);
  const categoryList = useSelector(
    (state) => state.productCategory.productCategorys
  );
  const unitList = useSelector((state) => state.productUnit.productUnits);

  useEffect(() => {
    dispatch(getProductCategorys());
    dispatch(getProductUnits());
    if (id === "new") {
      setForm(defaultForm);
    } else {
      getSlider(id);
    }
  }, [id]);

  const getSlider = async (id) => {
    const response = await dispatch(getProductPriceLevel(id));
    const data = (await response) && response.payload && response.payload.data;
    setForm(data || null);
  };

  const canBeSubmit = () => {
    if (form) {
      const isValid =
        form.name !== "" &&
        form.product_category_id !== "" &&
        form.product_unit_id !== "" &&
        form.description !== "";
      return isValid;
    }
    return false;
  };
  const onSubmit = () => {
    const updateForm = {
      ...form,
      product_category_id: form.product_category_id,
      product_unit_id: form.product_unit_id,
    };
    if (id === "new") {
      const res = dispatch(saveProductPriceLevel(updateForm))
        .then((response) => {
          if (
            response &&
            response.payload &&
            response.payload.statusCode === 201
          ) {
            toast.success(
              response && response.payload && response.payload.message
            );
            resetForm();
          }
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
          toast.error(error);
        });
    } else {
      const res = dispatch(updateProductPriceLevel(updateForm))
        .then((response) => {
          if (
            response &&
            response.payload &&
            response.payload.statusCode === 200
          ) {
            toast.success(
              response && response.payload && response.payload.message
            );
          }
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
          toast.error(error);
        });
    }
  };

  const handleSelect = (e) => {
    const { name, value } = e.target;
    if (name === "product_category_id") {
      const updateForm = {
        ...form,
        product_category_id: value,
      };
      setForm({ ...updateForm });
    }
    if (name === "product_unit_id") {
      const updateForm = {
        ...form,
        product_unit_id: value,
      };
      setForm({ ...updateForm });
    }
  };
  return (
    <div className="p-4">
      <div className="w-full flex items-center justify-between">
        <div
          className="flex items-center gap-2 text-sm hover:!cursor-pointer text-slate-500"
          onClick={() => navigate("/product-price-levels", { replace: true })}
        >
          <ArrowBack sx={{ fontSize: 14 }} />
          {t("Back to list")}
        </div>
        <Button
          color="secondary"
          variant="contained"
          type="button"
          disabled={!canBeSubmit()}
          onClick={() => onSubmit(form)}
        >
          {id !== "new" ? t("Update") : t("Save")}
        </Button>
      </div>
      <div className="my-6">
        <TextField
          label={t("Name")}
          name="level_name"
          value={form.level_name}
          onChange={handleChange}
          required
          error={form.level_name === ""}
          fullWidth
          margin="normal"
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>{t("Category")}</InputLabel>
          <Select
            name="product_category_id"
            label={t("Category")}
            value={form.product_category_id}
            onChange={handleSelect}
            error={form.product_category_id === ""}
          >
            {categoryList &&
              categoryList.length > 0 &&
              categoryList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>{t("Unit")}</InputLabel>
          <Select
            name="product_unit_id"
            label={t("Unit")}
            value={form.product_unit_id}
            onChange={handleSelect}
            error={form.product_unit_id === ""}
          >
            {unitList &&
              unitList.length > 0 &&
              unitList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <TextField
          label={t("Description")}
          name="level_description"
          value={form.level_description}
          onChange={handleChange}
          required
          error={form.level_description === ""}
          fullWidth
          margin="normal"
        />
      </div>
    </div>
  );
};

export default CreateProductPriceLevel;
